import React, { Component } from 'react';
import cn from 'classnames';
import qs from 'qs';
import styles from './SelectPlan.module.css';
import { find } from 'lodash';
import Button from 'forms/Button';
import { stripPlanWord } from '../utils';
import Checkbox from '../../../forms/Checkbox';

class SelectPlan extends Component {
  state = {
    termsAccepted: false,
  }

  componentDidMount() {
    this.fetchDevice();
  }
  componentDidUpdate(oldProps) {
    if (this.props.device && this.props.device !== oldProps.device) {
      this.fetchPlans();
    }
  }

  fetchDevice = () => {
    const { sku, findDevice } = this.props;
    findDevice(sku);
  }

  fetchPlans = () => {
    const { fetchInsurancePlansForValue, device: { value } } = this.props;
    fetchInsurancePlansForValue(value);
  }

  toggleTermsAccepted = () => {
    this.setState({ termsAccepted: !this.state.termsAccepted });
  }

  select = (plan) => {
    const { next, subId, sku } = this.props;
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    next(subId, sku, plan.id, query.deviceId);
  }

  render() {
    const { plans } = this.props;
    const { termsAccepted } = this.state;
    if (!plans || !plans.length) { return null; }

    const protectionPlan = find(plans, p => p.sku === 'WEWP');

    if ( !protectionPlan ) {
      return null;
    } 

    return (
      <div className={styles.SelectPlan}>
        <div className={styles.planWrapper}>
          <Plan
            plan={protectionPlan}
            className={cn(styles.plan, styles.middlePlan)}
            link="https://protect.likewize.com/ithappens/#Resources"
            btnType="btn"
            protections={protections}
            description="Protects your device against: Accidental damage, Malfunction & Water damage"
            onClick={() => this.select(protectionPlan)}
            termsAccepted={termsAccepted}
            onTermsClick={this.toggleTermsAccepted}
          />
        </div>
      </div>
    )
  }
}

const Plan = ({
  plan,
  className,
  link,
  protections,
  onClick,
  btnType,
  description,
  termsAccepted,
  onTermsClick,
}) => (
  <div className={className}>
    <div className={styles.top}>
      <h3>
        {stripPlanWord(plan.name)}
      </h3>
      <div className={styles.description}>
        {description}
      </div>
      <div className={styles.price}>
        ${plan.price}
      </div>
      <div className={styles.terms}>
        <Checkbox
          input={{ name: 'terms', value: termsAccepted, onChange: onTermsClick }}
          label={(
            <React.Fragment>
              I have read and agree to<br/> 
            </React.Fragment>
          )}
        /> 
        <a className={styles.termsLink} href={link} target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
      </div>
      <div className={styles.btnWrap}>
        <button className={styles[btnType]} onClick={onClick} disabled={!termsAccepted}>Select</button>
      </div>
    </div>
    <div className={styles.protections}>
      <div className={styles.listHeader}>Protects your device against</div>
      <ul className={styles.list}>
        {protections.map(item =>
          <li key={item}>{item}</li>
        )}
      </ul>
    </div>
    <div className={styles.footer}>
      <div className={styles.deductible}>
        Repair deductible: ${plan.repair_deductible}
      </div>
      <div className={styles.deductible}>
        Replacement deductible: ${plan.replacement_deductible}
      </div>
      <div className={styles.notes}>
        <p>*Loss and theft are not included in this plan. Any normal wear and tear, pre-existing flaws, or cosmetic damage are not protected.</p>
        <p>*Malfunction is protected after the manufacturer's warranty expires.</p>
        <p>*See plan Terms & Conditions for details, including the complete list of exclusions and limitations.</p>
      </div>
    </div>
  </div>
)

const protections = [
  'Accidental damage',
  'Water damage',
  'Mechanical Malfunction',
]

export default SelectPlan;
